import PageHero from "@/components/layout/PageHero";
import SEO from "@/components/layout/SEO";
import FeatureList from "@/components/layout/FeatureList";
import ConsultationForm from "@/components/forms/ConsultationForm";
import FinalCTA from "@/components/home/FinalCTA";
import { IMG, BOOKING_URLS } from "@/lib/content";

const ITEMS = [
  { title: "Admission-to-arrival roadmap", body: "A clear timeline from your offer letter to the day you land — no missing weeks." },
  { title: "Document preparation", body: "Translations, apostille, recognition, insurance and accommodation proof — prepared cleanly." },
  { title: "Visa procedures", body: "Guidance on appointments, requirements, supporting documents and the red flags to avoid." },
  { title: "Residence & settling in", body: "Registration, residence card, bank account, SIM card, first-month essentials." },
];

export default function VisaRelocation() {
  return (
    <div data-testid="page-visa-relocation">
      <SEO
        title="Polish student visa & relocation support"
        description="From admission letter to residence card — step-by-step visa, document preparation, and relocation guidance for international students moving to Poland."
        path="/visa-relocation"
      />
      <PageHero
        overline="Visa & Relocation"
        title={<>From admission letter to <span className="italic text-[#D7141A]">residence card</span>.</>}
        subtitle="The visa and relocation process is where most international students lose time, money and momentum. We help you get it right on the first try."
        image={IMG.visa}
        ctaPrimary={{ to: BOOKING_URLS.visa, label: "Book Consultation" }}
        ctaSecondary={{ to: "/free-resources", label: "Visa Roadmap" }}
      />
      <FeatureList
        overline="What we handle"
        title="Legal clarity. Practical support. No surprises."
        intro="We've walked hundreds of students through this process. We know where it usually breaks."
        items={ITEMS}
      />
      <section className="section-pad" data-testid="visa-consultation-form">
        <div className="container-sp grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="overline">Visa consultation</div>
            <h2 className="font-serif text-3xl sm:text-4xl text-[#0D1B2A] mt-3 leading-tight">Book a 30-minute clarity call.</h2>
            <p className="text-[#4A5568] mt-5 leading-relaxed">
              Bring your admission letter, current documents and timeline. You'll leave with a clear plan.
            </p>
          </div>
          <div className="lg:col-span-7">
            <ConsultationForm testPrefix="visa-consultation" />
          </div>
        </div>
      </section>
      <FinalCTA />
    </div>
  );
}
